import { stylesheet } from "typestyle";
import { classNames } from "./utils.js";
import * as React from "react";
export function Overlay({ open, className, children }) {
    return (React.createElement("div", { className: classNames(styles.overlay, open ? styles.open : styles.closed, className) }, children));
}
const styles = stylesheet({
    overlay: {
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        display: "flex",
        flexFlow: "column nowrap",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        transition: "opacity 0.25s",
    },
    closed: {
        visibility: "hidden",
        opacity: 0,
    },
    open: {
        visibility: "visible",
        opacity: 1
    }
});
//# sourceMappingURL=Overlay.js.map